import type { AccountFeatureFlag } from '@/services/auth/feature-flags';
import { useFeatureFlag } from '@/services/auth/feature-flags';

/**
 * Renders children only when the given feature flag is enabled.
 * Falls back to a custom fallback or renders nothing by default.
 * Subscribes to the account store, so guarded content reacts to flag
 * changes within a session (e.g. after a cross-app auth refresh).
 */

type FeatureFlagGuardProps = {
  flag: AccountFeatureFlag;
  fallback?: React.ComponentType;
  children: React.ReactNode;
};

export function FeatureFlagGuard({ flag, fallback: Fallback, children }: FeatureFlagGuardProps) {
  const isEnabled = useFeatureFlag(flag);

  if (isEnabled !== true) {
    return Fallback != null ? <Fallback /> : null;
  }

  return <>{children}</>;
}
